// extracted by mini-css-extract-plugin
export var animationContainer = "_h3-0";
export var asteriskIcon = "_h3-8";
export var conversationLeftSection = "_h3-4";
export var conversationListItem = "_h3-3";
export var conversationMiddleSection = "_h3-5";
export var conversationRightSection = "_h3-6";
export var detailsContent = "_h3-1";
export var listContainer = "_h3-7";
export var modalContent = "_h3-2";